

/**
 * @classdesc Système de dons pour un module
 * @kind class
 * @export
 * @prop {type} id - Id du système de dons
 * @prop {type} id_module - Id du module
 * @prop {boolean} actif - Le système de dons est actif
 * @prop {boolean} montant_libre - Proposer un montant libre
 * @prop {text} montants_proposes - Montants proposés
 * @prop {text} beneficiaire - Bénéficiaire du don
 * @prop {string} url_beneficiaire - Url du bénéficiaire
 * @prop {text} description - Description du système de dons
 * 
 * @class Donation
 */
export default class Donation {
    id;
    id_systeme_donation;
    id_module;
    actif = false;
    montant_libre = true;
    montants_proposes = "";
    beneficiaire = "";
    url_beneficiaire = "";
    description = "";
    montant = 0;

    /**
     * Creates an instance of Donation.
     * @constructs
     * @kind function
     * @memberof Donation
     */
    constructor(id_module) {
        this.id_module = id_module;

    }


    initialize_from_mainstore(data) {
        if (!data) return;
        this.id_systeme_donation = data.id;
        this.id_module = data.id_module;
        this.actif = data.actif;
        this.montant_libre = data.montant_libre;
        this.montants_proposes = data.montants_proposes;
        this.beneficiaire = data.beneficiaire;
        this.url_beneficiaire = data.url_beneficiaire;
        this.description = data.description;

    }

    get_montant_selectionne() {
        if (this.montant <= 0) {
            return 0;
        }
        let proposes = this.montants_proposes.split(";");
        for (let i = 0; i < proposes.length; i++) {
            if (proposes[i] == this.montant) {
                return this.montant;
            }
        }
        return -1;
    }

    get_montants_proposes() {
        let montants = [];
        montants.push({ text: "Non", value: 0 });
        let proposes = this.montants_proposes.split(";");
        for (let i = 0; i < proposes.length; i++) {
            if (proposes[i] == "") continue;
            montants.push({ text: proposes[i] + "€", value: proposes[i] });
        }
        if (this.montant_libre) {
            montants.push({ text: "Montant libre", value: -1 });
        }
        return montants;
    }


    set(data) {
        if (!data) return;
        this.id_systeme_donation = data.id;
        this.id_module = data.id_module;
        this.actif = data.actif;
        this.montant_libre = data.montant_libre;
        this.montants_proposes = data.montants_proposes;
        this.beneficiaire = data.beneficiaire;
        this.url_beneficiaire = data.url_beneficiaire;
        this.description = data.description;

        if (data.montant > 0) {
            this.montant = data.montant;
        }
    }

    set_id_module(id_module) {
        this.id_module = id_module;
    }

    update_cart() {
        let cart = { prix: 0, nb_articles: 0 };
        if (this.actif && this.montant > 0) {
            cart.prix = this.montant;
            cart.nb_articles = 1;
        }
        this.cart = cart;
        return cart;
    }

    set_active(montant) {
        this.actif = true;
        this.montant = montant;
    }

    getSimplifiedData() {
        if (!this.actif || this?.cart.prix == 0) {
            return null;
        }
        let infos = {};
        infos.montant = this?.cart.prix;
        return infos;
    }

}